import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { SupabaseMergeTagService } from "../../merge-tag/server/supabase-merge-tag-service";
import type { Tags } from "../../merge-tag/types";

export function useMergeTags(): ReturnType<typeof useSupabaseLoader<Tags>> {
  return useSupabaseLoader(async ({ supabase }) => {
    return new SupabaseMergeTagService(supabase).getAllMergeTags();
  }, []);
}
